import { createFileRoute } from "@tanstack/react-router";
import { CompanySettingsPage } from "@/pages/company-settings-page/company-settings-page.tsx";
import { getCompanySettings } from "@/api/requests/company-settings/get-company-settings.ts";
import { CompanySettings } from "@elton/types";

export const Route = createFileRoute("/_authenticated/companies/$companyId/_dashboard/settings")({
  component: CompanySettingsPage,
  loader: async ({ params }): Promise<{ settings: CompanySettings; companyId: string }> => {
    return { settings: await getCompanySettings(params.companyId), companyId: params.companyId };
  },
});
